import {
  customFetch,
  customFetch_POST,
  fetchCurrentUserData
} from "@/util/customFetch";
import { BACKEND_API_PLACEHOLDER } from "@/../environment.config";

const isOfflineDev = import.meta.env.VITE_OFFLINE_DEV === "true";
const {chemTargetsGlobalSuccess} = isOfflineDev ? await import("../tests/fixtures/ChemTargetsGlobal.js") : {};
const {sensorTargetsSuccess} = isOfflineDev ? await import("../tests/fixtures/SensorTargets.js") : {};

/**
 * @TODO I NEED CLEAN UP AND REFACTOR THIS ENTIRE FILE.
 * Fix Naming conventions, possibly split into different files. etc.
 * - Windley
 */

export async function createSensorTarget(data) {
    try {
        let response = await customFetch_POST(BACKEND_API_PLACEHOLDER + `/api/v1/sensors/target/`, JSON.stringify(data));
        return response;
    } catch (e) {
        console.log(e)
        return e
    }
}

export async function updateSensorTarget(data, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER +  `/api/v1/sensors/target/`, {
    method: 'PUT',
    headers: headers,
    body: JSON.stringify(data)
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function createTargetConsumable(data, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER +  `/api/v1/sensors/consumable/`, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(data)
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function createSensorGroup(data, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER +  `/api/v1/sensors/groups/chemical`, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(data)
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function getTankOutputs(serial) {
    try {
        let response = await fetch(BACKEND_API_PLACEHOLDER + `/api/v1/chemical/tank/outputs/${serial}`).then(async (response) => { return await response.json()});
        return response;
    } catch (e) {
        console.log(e)
        return {}
    }
}

export async function getAllSensorTargetsBySiteId(siteId, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER +  `/api/v1/sensors/targets/all?siteId=${siteId}`, {
    method: 'GET',
    headers: headers,
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function getAllSensorTargetsBySiteIdNoGrouping(siteId, headers) {
  if (!isOfflineDev) {
    let tokenData = await fetchCurrentUserData()
    headers = {...headers, ...tokenData}
    return fetch(BACKEND_API_PLACEHOLDER +  `/api/v1/sensors/targets?siteId=${siteId}`, {
      method: 'GET',
      headers: headers,
    })
      .then(res => res.json()
      .then(data => { return data })
    )
  }
  else return sensorTargetsSuccess
}

export async function getSensorTargetById(id)
{
    try {
        return await customFetch(BACKEND_API_PLACEHOLDER + `/api/v1/sensors/target/${id}`, 'GET');
    } catch (e) {
        console.log(e)
        return []
    }
}

export async function getConsumableInventoryAggregated(siteId, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER +  `/api/v1/sensors/consumable/aggregated?siteId=${siteId}`, {
    method: 'GET',
    headers: headers,
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function getAllSensors(headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER +  `/api/v1/sensors/sensors/`, {
    method: 'GET',
    headers: headers,
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function getSensorRelationship(sensorId, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER +  `/api/v1/sensors/relationship/sensor?sensor_id=${sensorId}`, {
    method: 'GET',
    headers: headers,
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function getConsumables()
{
    try {
        return await customFetch(BACKEND_API_PLACEHOLDER + `/api/v1/sensors/consumable/`, 'GET');
    } catch (e) {
        console.log(e)
        return {};
    }
}

export async function getConsumableCategories(headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER +  `/api/v1/sensors/consumable/categories`, {
    method: 'GET',
    headers: headers,
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function getFormulas(headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER +  `/api/v1/sensors/formulas/`, {
    method: 'GET',
    headers: headers,
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function getGroups(headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER +  `/api/v1/sensors/groups/chemical`, {
    method: 'GET',
    headers: headers,
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function getChemicals(site_id, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER +  `/api/v1/sensors/consumable/chemicals?siteId=${site_id}`, {
    method: 'GET',
    headers: headers,
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function getConsumableRelationshipsByCategoryId(category_id, site_id)
{
    try {
        return await customFetch(BACKEND_API_PLACEHOLDER + `/api/v1/sensors/consumable/relationships?category_id=${category_id}&site_id=${site_id}`, 'GET');
    } catch (e) {
        console.log(e)
        return {};
    }
}


export async function getTankChartData(sensor_target_id, timeframe, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER +  `/api/v1/sensors/charts?sensor_target_id=${sensor_target_id}&timeframe=${timeframe}`, {
    method: 'GET',
    headers: headers,
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function getContainerCarCounts(sensor_target_id, timeframe, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + `/api/v1/sensors/charts/car_counts?sensor_target_id=${sensor_target_id}&timeframe=${timeframe}`, {
    method: 'GET',
    headers: headers,
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function writeConsumableCategory(data, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER +  `/api/v1/sensors/consumable/category`, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(data)
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function forceSyncChemicalSensors(data, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER +  `/api/v1/sensors/force`, {
    method: 'POST',
    timeout: 20000,
    headers: headers,
    body: JSON.stringify({data})
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function removeChemicalFromConsumables(product_id, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER +  `/api/v1/sensors/consumable/product?product_id=${product_id}`, {
    method: 'DELETE',
    headers: headers,
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

/**
 * We retrieve from site scan an array of concatenated objects that are a merger of Wash Packages and Wash Sensors.
 * @param site_id
 * @returns {Promise<*|undefined|*[]>}
 */
export async function getAllSiteChemicalContainers(site_id, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER +  `/api/v1/chemical/containers?siteId=${site_id}`, {
    method: 'GET',
    headers: headers,
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

/**
 * We retrieve from site scan an array of concatenated objects that are a merger of Wash Packages and Wash Sensors.
 * @param site_id
 * @returns {Promise<*|undefined|*[]>}
 */
export async function getAllWashesAndWashSensorsCombined(site_id, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER +  `/api/v1/chemical/packages?siteId=${site_id}`, {
    method: 'GET',
    headers: headers,
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function updateWashToContainerRelationships(data, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER +  `/api/v1/chemical/packages`, {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(data)
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function getAllChemTargetsGlobal(headers) {
  if (!isOfflineDev) {
    let tokenData = await fetchCurrentUserData()
    headers = {...headers, ...tokenData}
    return fetch(BACKEND_API_PLACEHOLDER +  `/api/v1/chemical/chemical_monitoring/global`, {
        method: 'GET',
        headers: headers,
      })
      .then(res => res.json()
      .then(data => { return data })
    )
  }
  else return chemTargetsGlobalSuccess
}

export async function getChemSiteConfig(site_id, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER +  `/api/v1/chemical/chemical_monitoring/configuration?siteId=${site_id}`, {
    method: 'GET',
    headers: headers,
  })
  .then(res => res.json()
  .then(data => { return data })
)}

export async function getMultipleChemSiteConfigs(site_ids, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  let url = `${BACKEND_API_PLACEHOLDER}/api/v1/chemical/chemical_monitoring/configuration/multiple`
  let num = 0
  for (let siteId of site_ids) {
    url += (num === 0) ? `?siteId=${siteId}` : `&siteId=${siteId}`
    num++
  }
  return fetch(url, {
    method: 'GET',
    headers: headers,
  })
  .then(res => res.json()
  .then(data => { return data })
)}

export async function putEditChemSiteConfig(data, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER +  `/api/v1/chemical/chemical_monitoring/configuration/edit`, {
    method: 'PUT',
    body: JSON.stringify(data),
    headers: headers,
  })
  .then(res => res.json()
  .then(data => { return data })
)}

export async function postCreateChemSiteConfig(data, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER +  `/api/v1/chemical/chemical_monitoring/configuration/create`, {
    method: 'POST',
    body: JSON.stringify(data),
    headers: headers,
  })
  .then(res => res.json()
  .then(data => { return data })
)}

export async function getAllSiteChemicalData(site_id, headers) {
    let tokenData = await fetchCurrentUserData()
    headers = {...headers, ...tokenData}
    return fetch(BACKEND_API_PLACEHOLDER +  `/api/v1/chemical/chemical_monitoring?siteId=${site_id}`, {
        method: 'GET',
        headers: headers,
    })
        .then(res => res.json()
            .then(data => { return data })
        )
}


